module.exports = __webpack_public_path__ + "img/home-main.9614d4d6.png";